import { compose } from "redux";
import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import { IAction } from "../../../models/Action";
import { immutableSet } from "../../../utils/immutable";
import { actionTypes } from "./actions";
import emptyState from "./emptyState";

import { STATE_IDENTIFIER } from "./constants";

const {
  PROFILE_MGMT,
  SECURITY_QUESTIONS_MGMT,
  SECURITY_QUESTIONS,
  ID,
  OLD_ID,
  ANSWER,
  QUESTION,
  MISSING_QUESTIONS,
  CONFIG,
  DEFAULT_QUESTIONS,
  CONFIGS,
  REQUEST_STATE,
  ORIGINAL_SECURITY_QUESTIONS,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.VIEW_PROFILE_MGMT]: (state: any, action: any) =>
    immutableSet([PROFILE_MGMT], action, state),
  [actionTypes.VIEW_SECURITY_QUESTIONS_MGMT]: (state: any, action: any) =>
    immutableSet([SECURITY_QUESTIONS_MGMT], action, state),
  [actionTypes.DISPATCH_ANSWER_VALUE]: (state: any, action: any) =>
    immutableSet(
      [
        SECURITY_QUESTIONS_MGMT,
        SECURITY_QUESTIONS,
        action.payload.questionId,
        ANSWER,
      ],
      action.payload.answer,
      state
    ),
  [actionTypes.DISPATCH_QUESTION_VALUE]: (state: any, action: any) =>
    immutableSet(
      [
        SECURITY_QUESTIONS_MGMT,
        SECURITY_QUESTIONS,
        action.payload.questionId,
        QUESTION,
      ],
      action.payload.question,
      state
    ),

  [actionTypes.DISPATCH_SECURITY_QUESTION]: (state: any, action: any) =>
    immutableSet(
      [SECURITY_QUESTIONS_MGMT, SECURITY_QUESTIONS, action.payload.index],
      action.payload.sec
    )(state),

  [actionTypes.DISPATCH_OLD_ID]: (state: any, action: any) =>
    immutableSet(
      [
        SECURITY_QUESTIONS_MGMT,
        SECURITY_QUESTIONS,
        action.payload.index,
        OLD_ID,
      ],
      action.payload.oldId
    )(state),

  [actionTypes.DISPATCH_NEW_ID]: (state: any, action: any) =>
    immutableSet(
      [SECURITY_QUESTIONS_MGMT, SECURITY_QUESTIONS, action.payload.index, ID],
      action.payload.newId
    )(state),

  [actionTypes.GET_SECURITY_QUESTION_SUCCESS]: (state: any, action: any) => {
    return compose(
      immutableSet(
        [SECURITY_QUESTIONS_MGMT, SECURITY_QUESTIONS],
        action.payload
      ),
      immutableSet(
        [SECURITY_QUESTIONS_MGMT, ORIGINAL_SECURITY_QUESTIONS],
        action.payload
      )
    )(state);
  },
  [actionTypes.GET_SECURITY_QUESTION_FAILURE]: (state: any, action: any) =>
    compose(immutableSet([SECURITY_QUESTIONS_MGMT, SECURITY_QUESTIONS], []))(
      state
    ),

  [actionTypes.GET_CONFIG_SUCCESS]: (state: any, action: any) =>
    compose(
      immutableSet(
        [SECURITY_QUESTIONS_MGMT, CONFIG, DEFAULT_QUESTIONS],
        action.payload.defaultQuestions
      ),
      immutableSet(
        [SECURITY_QUESTIONS_MGMT, CONFIG, CONFIGS],
        action.payload.configurations
      ),
      immutableSet(
        [SECURITY_QUESTIONS_MGMT, CONFIG, MISSING_QUESTIONS],
        action.payload.missingQuestions
      )
    )(state),
  [actionTypes.GET_CONFIG_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([SECURITY_QUESTIONS_MGMT, CONFIG, DEFAULT_QUESTIONS], []),
      immutableSet([SECURITY_QUESTIONS_MGMT, CONFIG, CONFIGS], [])
    )(state),

  [actionTypes.POST_SECURITY_QUESTIONS]: (state: any, action: any) => {
    return immutableSet(
      [SECURITY_QUESTIONS_MGMT, REQUEST_STATE],
      IResponseState.PENDING,
      state
    );
  },
  [actionTypes.POST_SECURITY_QUESTIONS_SUCCESS]: (state: any, action: any) => {
    return compose(
      immutableSet(
        [SECURITY_QUESTIONS_MGMT, REQUEST_STATE],
        IResponseState.SUCCESS
      ),
      immutableSet([SECURITY_QUESTIONS_MGMT, SECURITY_QUESTIONS], [])
    )(state);
  },
  [actionTypes.POST_SECURITY_QUESTIONS_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [SECURITY_QUESTIONS_MGMT, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.location.pathname === "/profile-management"
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
